import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PostSurveySubmit } from "services/Api/Module/suervey";
import useUserProfile from "services/zustand/UserProfile";

const RegisterFlow2 = () => {
  const navigate = useNavigate();
  const { profile, setProfile } = useUserProfile();
  const [nextButton, setNextButton] = useState(true);
  const [formData, setFormData] = useState({
    firstname: profile.firstname ?? "",
    lastname: profile.lastname ?? "",
    mobileNo: profile.mobileNo ?? "",
    email: profile.email ?? "",
    pdpa: profile.pdpa ?? "",
  });
  const [errors, setErrors] = useState({
    mobileNo: "",
    email: "",
  });
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let error = "";

    if (name === "mobileNo") {
      if (!/^\d*$/.test(value)) {
        error = "กรุณากรอกเฉพาะตัวเลข";
      } else if (value.length > 10) {
        error = "หมายเลขโทรศัพท์ต้องไม่เกิน 10 หลัก";
      } else if (value.length < 10 && value !== "") {
        error = "หมายเลขโทรศัพท์ต้องมี 10 หลัก";
      }
      setErrors({ ...errors, mobileNo: error });
    }

    if (name === "email") {
      if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        error = "รูปแบบอีเมลไม่ถูกต้อง";
      }
      setErrors({ ...errors, email: error });
    }
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };
  const handleSubmit = () => {
    const payload = {
      mtcRef: profile.mtcRef,
      firstname: formData.firstname,
      lastname: formData.lastname,
      mobileNo: formData.mobileNo,
      email: formData.email,
      status: profile.status,
      surveyName: profile.surveyName,
    };
    // console.log("Form Data:", payload);
    fetchPostSubmitSurvey(payload);
  };
  const setZustand = () => {
    setProfile({
      firstname: formData.firstname,
      lastname: formData.lastname,
      mobileNo: formData.mobileNo,
      email: formData.email,
      pdpa: formData.pdpa,
    });
  };
  const fetchPostSubmitSurvey = async (payload) => {
    const response = await PostSurveySubmit({ data: payload });
    switch (response?.data?.resultCode) {
      case 20000:
        setProfile({
          mtcRef: "",
          firstname: "",
          lastname: "",
          mobileNo: "",
          email: "",
          status: "",
          pdpa: "",
        });
        navigate("/thankyou-flow2");
        break;
      default:
        console.log("error");
        break;
    }
    console.log(response);
  };

  useEffect(() => {
    const isFormComplete =
      formData.firstname.trim() &&
      formData.lastname.trim() &&
      formData.mobileNo.trim().length === 10 &&
      !errors.mobileNo &&
      formData.email.trim() &&
      !errors.email &&
      formData.pdpa;
    setNextButton(!isFormComplete);
  }, [formData, errors]);

  return (
    <div>
      <div id="pageRegister-flow2">
        <main>
          <div className="wrapContent">
            <section id="pBanner">
              <div className="bBanner">
                <div className="bPic">
                  <img src="/assets/img/ci/img-heart.svg" alt="" />
                </div>
                <div className="bText">
                  <p>
                    <span>ขอบคุณที่สละเวลากับเรา!</span>
                  </p>
                </div>
              </div>
            </section>
            <section id="pRegisterForm">
              <div className="bForm">
                <div className="bTitle">
                  <p>
                    {/* <span>ขออภัยเป็นอย่างยิ่ง</span> */}
                    ถ้าหากคุณเป็นผู้โชคดีที่ได้รับการสุ่มเลือก
                    <br /> เราจะติดต่อกลับไปทางอีเมลที่คุณแจ้งไว้
                    ภายในเดือนกุมภาพันธ์ 2026
                  </p>
                </div>
                <div className="bRow">
                  <div className="control-group validate">
                    <div className="tTitle">ชื่อ</div>
                    <input
                      type="text"
                      name="firstname"
                      value={formData.firstname}
                      onChange={handleChange}
                    />
                    <label htmlFor="" className="tError">
                      กรุณาระบุชื่อ
                    </label>
                  </div>
                </div>
                <div className="bRow">
                  <div className="control-group validate">
                    <div className="tTitle">นามสกุล</div>
                    <input
                      type="text"
                      name="lastname"
                      value={formData.lastname}
                      onChange={handleChange}
                    />
                    <label htmlFor="" className="tError">
                      กรุณาระบุนามสกุล
                    </label>
                  </div>
                </div>
                <div className="bRow">
                  <div
                    className={`bRow control-group validate ${
                      errors.mobileNo ? "error" : ""
                    }`}
                  >
                    <div className="tTitle">เบอร์โทรศัพท์</div>
                    <input
                      type="text"
                      name="mobileNo"
                      value={formData.mobileNo}
                      onChange={handleChange}
                      maxLength={10}
                    />
                    <label htmlFor="" className="tError">
                      {errors.mobileNo}
                    </label>
                  </div>
                </div>
                <div className="bRow">
                  <div
                    className={`bRow control-group validate ${
                      errors.email ? "error" : ""
                    }`}
                  >
                    <div className="tTitle">อีเมล</div>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    <label htmlFor="" className="tError">
                      {errors.email}
                    </label>
                  </div>
                </div>
                <div className="bRow">
                  <div className="control-group pdpa">
                    <label className="control control--checkbox">
                      <p>
                        ฉันยอมรับ{" "}
                        <a href="/privacy-policy" onClick={setZustand}>
                          นโยบายความเป็นส่วนตัว
                        </a>
                      </p>
                      <input
                        type="checkbox"
                        name="pdpa"
                        checked={formData.pdpa}
                        onChange={handleChange}
                      />
                      <div className="control__indicator"></div>
                    </label>
                    <label htmlFor="" class="tError">
                      Text Error Input
                    </label>
                  </div>
                </div>
              </div>
              <div className="bBtn">
                <button
                  onClick={handleSubmit}
                  className="btn"
                  disabled={nextButton}
                >
                  ยืนยันและส่งข้อมูล
                </button>
              </div>
            </section>
          </div>
        </main>
      </div>
    </div>
  );
};

export default RegisterFlow2;
